import React from 'react';
import { Col, Row } from 'reactstrap';
import { SingleDatePicker } from '../../../../../../../components/SingleDatePicker';
import { PushToHrisFormValues } from '../../..';
import { UseFormSetValue } from 'react-hook-form';
import moment from 'moment';
import { FormFieldHeader } from '../../../../../../../components/FormFieldHeader';

interface PropTypes {
  startDate: Date;
  setValue: UseFormSetValue<PushToHrisFormValues>;
}

export function StartingDateRow(props: PropTypes) {
  return (
    <Row className='mb-3'>
      <Col sm={6}>
        <FormFieldHeader fieldName={'Starting Date'} isRequired={false} />
        <SingleDatePicker
          dateFilter={{
            start: props.startDate && moment(props.startDate),
          }}
          minDate={undefined}
          onChange={(date) => props.setValue('startDate', date.toDate())}
          buttonType='button'
          drops='up'
        />
      </Col>
    </Row>
  );
}
